import { Wrapper } from '~/components/dialogs/Wrapper'
import { Contact } from '~/components/Contact'
import { HEALTH_GATEWAY_URL } from '~/utils/constants'

export const Success = () => {
  return (
    <Wrapper>
      <SuccessContent />
    </Wrapper>
  )
}
export const SuccessContent = ({ close }) => {
  const handleClick = () => {
    window.location.replace(
      'http://www.transplant.bc.ca/about/news-stories/organ-donation-transplant-stories',
    )
  }

  return (
    <>
      <h4 className="pb-3 text-4xl font-semibold text-primary-green">Thank you</h4>
      <div className="mb-2 pb-4 text-2xl font-semibold text-[#666666]">
        Your decision has successfully been recorded in the Organ Donor Registry.
      </div>
      <div className="leading-7 text-[#333333]">
        <p className="pb-4">
          You only need to register one time. If you would like to change your decision on record,
          you can do so by completing this registration process again.
        </p>
        <p className="pb-4">
          If you have any questions,&nbsp;
          <Contact />
        </p>
        <p>
          You can check your registration status and review your decision details in Health Gateway.
          Any new or updated registrations may take 2 hours to show in{' '}
          {/* eslint-disable-next-line */}
          <a href={HEALTH_GATEWAY_URL} target="_blank">
            Health Gateway
          </a>
          .
        </p>
      </div>
      <div className="float-right">
        <button
          type="button"
          className="rounded-full bg-primary-blue px-6 py-2 text-2xl text-slate-50 transition-colors duration-300 hover:bg-primary-blue/80"
          onClick={handleClick}
        >
          Return to Site &gt;
        </button>
      </div>
    </>
  )
}
